import { render, staticRenderFns } from "./LogEntryInformation.vue?vue&type=template&id=2b674ab4&scoped=true&"
import script from "./LogEntryInformation.vue?vue&type=script&lang=js&"
export * from "./LogEntryInformation.vue?vue&type=script&lang=js&"
import style0 from "./LogEntryInformation.vue?vue&type=style&index=0&id=2b674ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b674ab4",
  null
  
)

export default component.exports